export default "__VITE_ASSET__DwlY0pGE__"